import { render, staticRenderFns } from "./viewPartner.vue?vue&type=template&id=32a8912e&scoped=true"
import script from "./viewPartner.vue?vue&type=script&lang=js"
export * from "./viewPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a8912e",
  null
  
)

export default component.exports